export enum BtnCtaPromiseState {
    DEFAULT = 'default',
    PROGRESS = 'progress',
    SUCCESS = 'success',
}
